import React, { useState,  } from "react";
import axios from "axios";
const { getNewYorkDateTime } = require("../utils/dateUtils");
export default function AgentsWithFiltersAndUpdate() {
const [, setAgents] = useState([]); // ignore state, only setter

  const [filtered, setFiltered] = useState([]);   // filtered agents

  const [loading, setLoading] = useState(false);
 const [loadingRow, setLoadingRow] = useState({});


  // Checkbox selection
  const [, setSelectedAgents] = useState([]); // store _ids
const [selectedProduct, setSelectedProduct] = useState(""); // for dropdown



const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");






// const processSelectedAgents = async () => {
  

//   try {
//     const payload = {
//       APIKey: "675fe209-31de-4c06-b5ce-93d5dd21628a",  
//       IPAmount: "3.72",
//       MonthlyPayment: "38.92",
//       PaymentType: "1",
//          OrderType: "3",
//       domain: "wv.com",
//       buildorder: 1,
//       MerchantID: "0",
//       capture_delay: 0,
//             amount: "39.64",
//       ProductCount: 1,
//       productid_1: "113",

//       card_num: "5332480566894129",
//       card_expm: "12",
//       card_expy: "2028",
//       cvv: "123",
//       BillingStreetAddress: "123 Main Street",
//       BillingApt: "",
//       BillingCity: "Springfield",
//       BillingState: "CA",
//       BillingZipCode: "90001",
//       Email: "johndoe@example.com",
//       DOB: "01/01/1990",
//        CustomerLastName: "Doe",
//       CustomerFirstName: "John",
//       CustomerAddress1: "123 Main Street",
//       CustomerCity: "Springfield",
//       CustomerState: "CA",
//       CustomerZip: "90001",
//       CustomerHomePhone: "5551234567",
//       CardNumber: "5332480566894129",
//       CardExpMonth: "12",
//       CardExpYear: "2028",
//       CardHolderName: "John Doe",

//       SalesDate: "01/01/2025",
//       VerifyDate: "01/01/2025",
//       IPBillDate: "01/01/2025",
//       NextBillDate: "01/19/2025",
//     };

//     const res = await axios.post("http://13.62.197.24/api/test-order", payload);

//     console.log("📌 API RESPONSE:", res.data);
//     console.log("📌 RAW RESPONSE:", res);

//   } catch (error) {
//     console.error("❌ API ERROR:", error);
//     console.error("❌ ERROR RESPONSE:", error.response?.data);
//   }
// };




// const processSelectedAgents = async () => {
//   try {
//     if (selectedAgents.length === 0) {
//       alert("Please select at least one record.");
//       return;
//     }

//     // 1️⃣ GET SELECTED ROW DATA
//     const selectedRows = filtered.filter(row => selectedAgents.includes(row._id));

//     console.log("📌 Selected Rows:", selectedRows);

//     // 2️⃣ LOOP OVER EACH SELECTED ROW AND SEND TO API
//     for (const row of selectedRows) {

//       const payload = {
//         APIKey: "675fe209-31de-4c06-b5ce-93d5dd21628a",
//         IPAmount: "3.72",
//         MonthlyPayment: "38.92",
//         PaymentType: "1",
//         OrderType: "3",
//         domain: "wv.com",
//         buildorder: 1,
//         MerchantID: "0",
//         capture_delay: 0,
//         amount: "39.64",
//         ProductCount: 1,
//         productid_1: "113",

//         // 🔥 DYNAMIC VALUES FROM TABLE ROW
//         Email: row.email,
//         CustomerFirstName: row.firstName,
//         CustomerLastName: row.lastName,
//         CustomerAddress1: row.address,
//         CustomerCity: row.city,
//         CustomerState: row.state,
//         CustomerZip: row.zip,
//         CustomerHomePhone: row.phone,

//         // CARD INFO FROM ROW
//         CardNumber: row.cardNumber,
//         CardExpMonth: row.expiry?.split("/")?.[0] || "",
//         CardExpYear: row.expiry?.split("/")?.[1] || "",
//         cvv: row.cvv,

//         // DOB
//         DOB: row.dob,

//         // Billing (use same as customer)
//         BillingStreetAddress: row.address,
//         BillingCity: row.city,
//         BillingState: row.state,
//         BillingZipCode: row.zip,

//         // HARDCODED SAMPLE FIELDS
//         SalesDate: row.verifiedDate,
//         VerifyDate: row.verifiedDate,
//         IPBillDate: row.verifiedDate,
//         NextBillDate: "01/19/2025",
//       };

//       console.log("📌 FINAL PAYLOAD SENT:", payload);

//       const res = await axios.post("http://13.62.197.24/api/test-order", payload);

//       console.log("✅ API SUCCESS FOR:", row._id);
//       console.log("📌 RESPONSE:", res.data);
//     }

//   } catch (error) {
//     console.error("❌ API ERROR:", error);
//     console.error("❌ ERROR RESPONSE:", error.response?.data);
//   }
// };



//28-11-2025------------------------------------------------------------------------------

// const processSelectedAgents = async () => {
//   try {
//     if (selectedAgents.length === 0) {
//       alert("Please select at least one record.");
//       return;
//     }

//     // Get selected rows
//     const selectedRows = filtered.filter(row => selectedAgents.includes(row._id));

//     console.log("📌 Selected Rows:", selectedRows);

//     for (const row of selectedRows) {
//       // Determine product config based on selectedProduct
//       let productConfig = {
//         productid_1: "DEFAULT",
//         IPAmount: "0",
//         MonthlyPayment: "0",
//         OrderType: "0",
//         NextBillDate: "",
//       };

//       if (selectedProduct === "MD") {
//         productConfig.productid_1 = "116";
//         productConfig.IPAmount = "3.78";
//         productConfig.MonthlyPayment = "39.64";
//         productConfig.OrderType = "6";

//         if (row.verifiedDate) {
//           const date = new Date(row.verifiedDate);
//           date.setDate(date.getDate() + 14);
//           productConfig.NextBillDate = `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getDate().toString().padStart(2, "0")}/${date.getFullYear()}`;
//         }
//       } else if (selectedProduct === "ID") {
//         productConfig.productid_1 = "113";
//         productConfig.IPAmount = "3.72";
//         productConfig.MonthlyPayment = "38.92";
//         productConfig.OrderType = "3";

//         if (row.verifiedDate) {
//           const date = new Date(row.verifiedDate);
//           date.setDate(date.getDate() + 10);
//           productConfig.NextBillDate = `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getDate().toString().padStart(2, "0")}/${date.getFullYear()}`;
//         }
//       }

//       // Build payload
//       const payload = {
//         APIKey: "675fe209-31de-4c06-b5ce-93d5dd21628a",
//         IPAmount: productConfig.IPAmount,
//         MonthlyPayment: productConfig.MonthlyPayment,
//         PaymentType: "1",
//         OrderType: productConfig.OrderType,
//         domain: "wv.com",
//         buildorder: 1,
//         MerchantID: "0",
//         capture_delay: 0,
//         amount: productConfig.MonthlyPayment,
//         ProductCount: 1,
//         productid_1: productConfig.productid_1,
//         NextBillDate: productConfig.NextBillDate,
//         Email: row.email,
//         CustomerFirstName: row.firstName,
//         CustomerLastName: row.lastName,
//         CustomerAddress1: row.address,
//         CustomerCity: row.city,
//         CustomerState: row.state,
//         CustomerZip: row.zip,
//         CustomerHomePhone: row.phone,
//         CardNumber: row.cardNumber?.replace(/-/g, "") || "",
//         CardExpMonth: row.expiry?.split("/")?.[0] || "",
//         CardExpYear: row.expiry?.split("/")?.[1] || "",
//         cvv: row.cvv,
//         DOB: row.dob,
//         BillingStreetAddress: row.address,
//         BillingCity: row.city,
//         BillingState: row.state,
//         BillingZipCode: row.zip,
//         SalesDate: row.verifiedDate,
//         VerifyDate: row.verifiedDate,
//         IPBillDate: row.verifiedDate,
//       };

//       console.log("📌 FINAL PAYLOAD SENT:", payload);

//       try {
//         // Send to API
//         const res = await axios.post("http://13.62.197.24/api/test-order", payload);
//         console.log("✅ API SUCCESS FOR:", row._id, res.data);

//         // Extract response fields
//         const apiStatus = res.data.success ? "Success" : "Failed";
//         const apiCode = res.data.data?.ResponseCode || "";
//         const apiMessage = res.data.data?.ResponseData || "";

//         const apiDate = new Date().toISOString();

//         // --------------- UPDATE DATABASE ---------------
//         await axios.put(`https://crm-server-htk6.vercel.app/api/agents/${row._id}`, {
//           APIStatus: apiStatus,
//           APIResponseCode: apiCode,
//           APIResponseMessage: apiMessage,
//           APIDate: apiDate,
//         });

//         // --------------- UPDATE TABLE IN RUNTIME ---------------
//         setAgents((prev) =>
//           prev.map((a) =>
//             a._id === row._id
//               ? {
//                   ...a,
//                   APIStatus: apiStatus,
//                   APIResponseCode: apiCode,
//                   APIResponseMessage: apiMessage,
//                   APIDate: apiDate,
//                 }
//               : a
//           )
//         );
//         setFiltered((prev) =>
//           prev.map((a) =>
//             a._id === row._id
//               ? {
//                   ...a,
//                   APIStatus: apiStatus,
//                   APIResponseCode: apiCode,
//                   APIResponseMessage: apiMessage,
//                   APIDate: apiDate,
//                 }
//               : a
//           )
//         );

//       } catch (apiError) {
//         console.error("❌ API ERROR FOR ROW:", row._id, apiError.response?.data || apiError.message);
//       }
//     }
//   } catch (error) {
//     console.error("❌ PROCESS ERROR:", error);
//   }
// };



const processSingleAgent = async (row) => {
 // Start loading ONLY for this row
  setLoadingRow((prev) => ({ ...prev, [row._id]: true }));

  try {
    // Determine product config
    let productConfig = {
      productid_1: "DEFAULT",
      IPAmount: "0",
      MonthlyPayment: "0",
      OrderType: "0",
      NextBillDate: "",
    };

    if (selectedProduct === "MD") {
      productConfig.productid_1 = "116";
      productConfig.IPAmount = "3.78";
      productConfig.MonthlyPayment = "39.64";
      productConfig.OrderType = "6";

      if (row.verifiedDate) {
        const date = new Date(row.verifiedDate);
        date.setDate(date.getDate() + 14);
        productConfig.NextBillDate = `${(date.getMonth() + 1)
          .toString()
          .padStart(2, "0")}/${date
          .getDate()
          .toString()
          .padStart(2, "0")}/${date.getFullYear()}`;
      }
    } else if (selectedProduct === "ID") {
      productConfig.productid_1 = "113";
      productConfig.IPAmount = "3.72";
      productConfig.MonthlyPayment = "38.92";
      productConfig.OrderType = "3";

      if (row.verifiedDate) {
        const date = new Date(row.verifiedDate);
        date.setDate(date.getDate() + 10);
        productConfig.NextBillDate = `${(date.getMonth() + 1)
          .toString()
          .padStart(2, "0")}/${date
          .getDate()
          .toString()
          .padStart(2, "0")}/${date.getFullYear()}`;
      }
    }
const [expMonth, expYear] = row.expiry?.split("/") || ["", ""];
    // Build payload
    const payload = {
      APIKey: "675fe209-31de-4c06-b5ce-93d5dd21628a",
     // IPAmount: productConfig.IPAmount,
     // MonthlyPayment: productConfig.MonthlyPayment,
      PaymentType: "1",
      OrderType: productConfig.OrderType,
      domain: "wv.com",
      buildorder: 1,
      MerchantID: "0",
      capture_delay: 0,
      amount: productConfig.IPAmount,
      ProductCount: 1,
      productid_1: productConfig.productid_1,
      NextBillDate: productConfig.NextBillDate,

      Email: row.email,
      CustomerFirstName: row.firstName,
      CustomerLastName: row.lastName,
      BillingHomePhone: row.phone,
      card_num: row.cardNumber?.replace(/-/g, "") || "",
     card_expm: expMonth,
  card_expy: expYear.length === 2 ? `20${expYear}` : expYear,
      card_cvv: row.cvv,
CardHolderName:row.firstName,
      DOB: row.dob,
      BillingStreetAddress: row.address,
      BillingCity: row.city,
      BillingState: row.state,
      BillingZipCode: row.zip,
      SalesDate: row.verifiedDate,
      VerifyDate: row.verifiedDate,
      IPBillDate: row.verifiedDate,
    };
//console.log("📦 Payload Sent:", payload);

    // Send to API
    const res = await axios.post("https://cbsapi.i-crm.cc/api/test-order", payload);
    // 🔥 Print EVERYTHING from API
//console.log("🔥 FULL API RESPONSE:", JSON.stringify(res.data, null, 2));

    const apiStatus = res.data.success ? "Success" : "Failed";
    const apiCode = res.data.data?.ResponseCode || "";
    const apiMessage = res.data.data?.ResponseData || "";
    const apiOrderNumber = res.data.data?.OrderNumber || "";
    const apiDate = getNewYorkDateTime();  

    // Update DB
// Build update fields based on MD or ID
let updateFields = {};

if (selectedProduct === "MD") {
  updateFields = {
    APIStatus: apiStatus,
    APIResponseCode: apiCode,
    APIResponseMessage: apiMessage,
    APIDate: apiDate,
    ApiOrderNumber:apiOrderNumber,
  };
} else if (selectedProduct === "ID") {
  updateFields = {
    IDAPIStatus: apiStatus,
    IDAPIResponseCode: apiCode,
    IDAPIResponseMessage: apiMessage,
    IDAPIDate: apiDate,
    IDApiOrderNumber:apiOrderNumber,
  };
}

// Update DB
await axios.put(
  `https://crm-server-htk6.vercel.app/api/agents/${row._id}`,
  updateFields
);

// Update UI Live
setAgents((prev) =>
  prev.map((a) => (a._id === row._id ? { ...a, ...updateFields } : a))
);

setFiltered((prev) =>
  prev.map((a) => (a._id === row._id ? { ...a, ...updateFields } : a))
);


    // Update UI Live
    setAgents((prev) =>
      prev.map((a) =>
        a._id === row._id
          ? {
              ...a,
              APIStatus: apiStatus,
              APIResponseCode: apiCode,
              APIResponseMessage: apiMessage,
              APIDate: apiDate,
              IDApiOrderNumber:apiOrderNumber,
            }
          : a
      )
    );

    setFiltered((prev) =>
      prev.map((a) =>
        a._id === row._id
          ? {
              ...a,
              APIStatus: apiStatus,
              APIResponseCode: apiCode,
              APIResponseMessage: apiMessage,
              APIDate: apiDate,
              ApiOrderNumber:apiOrderNumber,
            }
          : a
      )
    );
  } catch (error) {
 //   console.error("❌ Single Row API Error:", error);
  } finally {
   // Stop loading only for this row
    setLoadingRow((prev) => ({ ...prev, [row._id]: false }));
  }
};




const handleProductFilter = async () => {
  if (!selectedProduct) {
    alert("Please select a product first.");
    return;
  }

  try {
    setLoading(true);

    const params = new URLSearchParams();
    params.append("product", selectedProduct);

    if (fromDate && toDate) {
      params.append("fromDate", fromDate); // <-- send as "YYYY-MM-DD"
      params.append("toDate", toDate);
    }

    const res = await axios.get(
      `https://crm-server-htk6.vercel.app/api/agents/product-filter?${params.toString()}`
    );

    setAgents(res.data);
    setFiltered(res.data);
    setSelectedAgents([]);

  } catch (err) {
    console.error("❌ Error fetching filtered agents:", err);
  } finally {
    setLoading(false);
  }
};


const safeText = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") return JSON.stringify(value); 
  return value;
};

  return (
    <div style={{ padding: "20px" }} className="allforms-container">
      <h2>Charge Processing</h2>
{loading && (
  <div className="loading-popup">
    <p>Processing... Please wait</p>
  </div>
)}

      {/* ---- Filter Inputs ---- */}
    <div className="form-row" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
  
  {/* Product Dropdown */}
  <select
    value={selectedProduct}
    onChange={(e) => setSelectedProduct(e.target.value)}
    style={{
      padding: "8px 12px",
      fontSize: "14px",
      borderRadius: "5px",
      border: "1px solid #ccc",
      minWidth: "150px",
    }}
  >
    <option value="">Select Product</option>
    <option value="MD">MD</option>
    <option value="ID">ID</option>
  </select>

  {/* From Date */}
  <input
    type="date"
    value={fromDate}
    onChange={(e) => setFromDate(e.target.value)}
    style={{
      padding: "8px",
      borderRadius: "5px",
      border: "1px solid #ccc"
    }}
  />

  {/* To Date */}
  <input
    type="date"
    value={toDate}
    onChange={(e) => setToDate(e.target.value)}
    style={{
      padding: "8px",
      borderRadius: "5px",
      border: "1px solid #ccc"
    }}
  />

  {/* Go Button */}
  <button
    className="btn save"
    onClick={handleProductFilter}
    style={{
      padding: "8px 16px",
      fontSize: "14px",
      borderRadius: "5px",
      backgroundColor: "#4CAF50",
      color: "#fff",
      border: "none",
      cursor: "pointer",
    }}
  >
    Go
  </button>
</div>


      {/* ---- User Dropdown + Update Button ---- */}

      {loading ? (
        <p>⏳ Loading...</p>
      ) : (
        <div
  className="table-container1" style={{ marginTop: "20px", overflowX: "auto" 
  }}
>


<table className="report-table table-container" style={{ borderCollapse: "collapse", width: "100%" }}>
<thead>
<tr>
{/* ⭐ NEW FIELDS ⭐ */}
<th>CustomerID</th>
<th>First Name</th>
<th>Last Name</th>
<th>Email</th>
<th>Phone</th>
<th>Charge</th>

<th>ApiOrderNumber</th>

<th>Message</th>
<th>APIDate</th>


</tr>
</thead>


<tbody>
  {filtered.length === 0 ? (
    <tr>
      <td colSpan="11" style={{ textAlign: "center" }}>No records found</td>
    </tr>
  ) : (
    filtered.map((a) => (
      <tr key={a._id} style={{ borderBottom: "1px solid #ddd" }}>
        
        {/* REMOVE CHECKBOX COLUMN */}
        <td>{a.CustomerID || ""}</td>

        <td>{a.firstName || ""}</td>
        <td>{a.lastName || ""}</td>
        <td>{a.email || ""}</td>
        <td>{a.phone || ""}</td>
         <td>
     <button
  className="btn save"
  onClick={() => processSingleAgent(a)}
  disabled={loadingRow[a._id]} // disable only this row's button
  style={{
    padding: "6px 12px",
    fontSize: "13px",
    backgroundColor: "#007bff",
    color: "#fff",
    borderRadius: "5px",
    cursor: "pointer",
  }}
>
  {loadingRow[a._id] ? (
    <>
      <span className="spinner-border spinner-border-sm me-2"></span>
      Processing...
    </>
  ) : (
    "Post API"
  )}
</button>

        </td>
       {/* <td>
  {selectedProduct === "MD"
    ? safeText(a.APIStatus)
    : safeText(a.IDAPIStatus)}
</td> */}

  <td>
  {selectedProduct === "MD"
    ? safeText(a.ApiOrderNumber)
    : safeText(a.IDApiOrderNumber)}
</td>


<td>
  {selectedProduct === "MD"
    ? safeText(a.APIResponseMessage)
    : safeText(a.IDAPIResponseMessage)}
</td>

<td>
  {selectedProduct === "MD"
    ? safeText(a.APIDate)
    : safeText(a.IDAPIDate)}
</td>

        {/* ⭐ NEW POST BUTTON IN EVERY ROW ⭐ */}
       

      </tr>
    ))
  )}
</tbody>

</table>
        </div>
      )}
    </div>
  );
}
